import APIV3 from '../../../../api/axios/APIV3';

export const fetchAddonGroupChoices = async (outletId, addonGroupId) => {
    let response;

    try {
        response = await APIV3.get(
            `/restaurants/:restaurantId/outlets/${outletId}/addon-groups/${addonGroupId}/choices/stock`
        );
    } catch (error) {
        response = {
            error: error,
        };
    }

    return response;
};
